module.exports = __webpack_public_path__ + "static/media/black-md-arrow.238e2a60.svg";